module.exports = __webpack_public_path__ + "static/media/addItem.3979065e.svg";